import { Modal, Radio, Typography } from 'antd';

export default function CreateInvoiceModal({
  n_transactions,
  open,
  setOpen,
  onOk,
}) {
  const { Text } = Typography;

  return (
    <Modal
      title="Create Invoice"
      open={open}
      onCancel={() => setOpen(false)}
      onClose={() => setOpen(false)}
      onOk={onOk}
    >
      <Text strong>You are going to trigger invoice creation.</Text>
      <br />
      <Text>Do you want to continue?</Text>
    </Modal>
  );
  // return (
  //   <Modal
  //     title="Create Invoice"
  //     open={open}
  //     onCancel={() => setOpen(false)}
  //     onClose={() => setOpen(false)}
  //   >
  //     <Text>Choose how you would like to compile your invoice:</Text>
  //     <Radio.Group
  //       defaultValue={'selected'}
  //       options={[
  //         {
  //           value: 'selected',
  //           label: (
  //             <div style={{ margin: '10px 0' }}>
  //               <Text>
  //                 Selected transactions only -{' '}
  //                 <Text strong>
  //                   {n_transactions || 0} transactions selected
  //                 </Text>
  //               </Text>
  //               <br />
  //               <Text italic>
  //                 Includes only eligible transactions marked as Ready for
  //                 Invoice or Ready for Finance Review
  //               </Text>
  //             </div>
  //           ),
  //         },
  //         {
  //           value: 'all',
  //           label: 'All transactions',
  //         },
  //       ]}
  //     />
  //   </Modal>
  // );
}
